// export const BASE_HOST_URL = 'http://localhost:3005'
// export const BASE_HOST_URL = 'https://bookings.cabanyesentrevalls.com'
// export const BASE_HOST_URL = 'http://bookingenginecev5-env.eba-qmrxqusm.eu-west-1.elasticbeanstalk.com';
export const BASE_HOST_URL = 'https://cev-booking.herokuapp.com';


// WEBPACK FOOTER //
// ./src/config/index.js